import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import HeaderVelkie from "./HeaderVelkie";
import BetSlipVelkie from "./BetSlipVelkie";
import BetSlipContext from "../../context/BetSlipContext";
import BottomNavigation from "./BottomNavigation";
import { isEmpty } from "lodash";
import BetSlipParlayVelkie from "./BetSlipParlayVelkie";
import NewToast from "./ToastVelkie";
import MyBetsVelkie from "./MyBetsVelkie";
import { useEffect, useState } from "react";
import SidebarVelkie from "./SidebarVelkie";
import { isMobile } from "react-device-detect";

const VelkieLayout = (props) => {
  const { children, visibilityType, page } = props;
  const { type } = useParams();
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setSidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModal;
  });
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });

  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const toastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.toastObject;
  });
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const showParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.showParlyBet;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const setShowParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowParlyBet;
  });
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const showBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.showBets;
  });

  const location = useLocation();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500); // adjust duration

    return () => clearTimeout(timer);
  }, [location]); // ⚡ use location.key instead of pathname

  return isMobile ? (
    <div className="main-outer ">
      <section
        id="main-container"
        // style={{ overflowX: "hidden", minHeight: "100%" }}
        className="relative col-start-2 col-end-2 container h-screen mx-auto overflow-y-scroll overflow-x-hidden bg-black-100"
      >
        <Outlet />
        <HeaderVelkie />
        <main className="min-h-full-with-header-footer">
          {children}
          <BetSlipVelkie />
        </main>
        {!["match-detail-velki", "menu"].includes(
          location?.pathname?.split("/")[1]
        ) && <BottomNavigation />}
        {sidebarModal && <SidebarVelkie setSidebarModal={setSidebarModal} />}
        {showBets && <MyBetsVelkie />}
        {loading && (
          <div
            data-v-5837125a
            data-v-fa12c4fa
            className="loading-wrapper fixed left-0 top-0 z-50 w-full h-full flex justify-center items-center text-xl text-center text-primary"
          >
            <div
              data-v-5837125a
              className="loading-body w-28 h-28 flex justify-center items-center border border-solid border-primary rounded-lg"
            >
              <div data-v-5837125a className="loading-spinner relative w-1/2" />
            </div>
          </div>
        )}

        {toastObject?.status && (
          <NewToast
            type={toastObject?.type}
            title={toastObject?.title}
            message={toastObject?.message}
            onClose={() => {
              setToastObject({});
              setBetSlipObject({});
            }}
            playType={toastObject?.playType}
          />
        )}

        {(parlay || type == "multi") &&
          parlyBet?.length > 0 &&
          !isEmpty(user) && (
            <div
              onClick={() => setShowParlyBet(true)}
              data-v-63c2856d
              className="stickyLeftContainer fixed left-2 z-10 pb-7px flex gap-2 flex-col justify-end items-end"
              style={{ "--772806b8": "4.3rem" }}
            >
              <div className="relative cursor-pointer flex flex-col items-center justify-center w-45px h-45px rounded-full bg-primary text-menu-active-icon font-bold">
                <span className="absolute text-22 icon-parlay-list" />
                <span className="absolute flex justify-center items-center rounded-full w-4 h-4 text-9 font-bold text-white bg-parlay-down top-1.5 right-1.5">
                  <span className="scale-75">{parlyBet?.length}</span>
                </span>
              </div>
            </div>
          )}
        {showParlyBet && parlyBet?.length > 0 && !isEmpty(user) && (
          <BetSlipParlayVelkie />
        )}
        {location?.pathname?.split("/")[1] != "menu" && (
          <>
            <div className="flex justify-center items-center flex-col text-center mt-40px">
              <Link to="#" className="inline-block mb-1">
                <img
                  alt="android download"
                  width={115}
                  height={41}
                  className="w-120px h-auto mx-auto"
                  src={require("../../assets/images/btn-android-dl.webp")}
                />
              </Link>
              <span className="text-11 text-black-600">
                v1.11 - 2022/3/8 - 2.6MB
              </span>
              <p className="test-app" />
            </div>
            <div className="social relative flex justify-center items-center py-20px">
              <a
                href="https://t.me/akash_malik"
                target="_blank"
                className="block cursor-pointer mx-1"
              >
                <span className="text-30 icon-telegram" />
              </a>
              <a
                href={+447520636263}
                target="_blank"
                className="block cursor-pointer mx-1"
              >
                <div
                  data-v-5a06812e
                  className="icon-whatsapp text-30 block cursor-pointer mx-1"
                />
              </a>

              <a
                href="https://www.facebook.com/groups/velki.live"
                target="_blank"
                className="block cursor-pointer mx-1"
              >
                <span className="text-30 icon-facebook" />
              </a>
            </div>{" "}
            <div data-v-83be86ac className="px-3 mb-10px text-center">
              <ul data-v-83be86ac>
                <li
                  data-v-83be86ac
                  className="pb-2 inline-block align-middle cursor-pointer"
                >
                  <span
                    data-v-83be86ac
                    className="block px-2 text-11 border-r border-black-300"
                  >
                    Privacy Policy
                  </span>
                </li>
                <li
                  data-v-83be86ac
                  className="pb-2 inline-block align-middle cursor-pointer"
                >
                  <span
                    data-v-83be86ac
                    className="block px-2 text-11 border-r border-black-300"
                  >
                    Terms and Conditions
                  </span>
                </li>
                <li
                  data-v-83be86ac
                  className="pb-2 inline-block align-middle cursor-pointer"
                >
                  <span
                    data-v-83be86ac
                    className="block px-2 text-11 border-r border-black-300"
                  >
                    Rules and Regulations
                  </span>
                </li>
                <li
                  data-v-83be86ac
                  className="pb-2 inline-block align-middle cursor-pointer"
                >
                  <span
                    data-v-83be86ac
                    className="block px-2 text-11 border-r border-black-300"
                  >
                    KYC
                  </span>
                </li>
                <li
                  data-v-83be86ac
                  className="pb-2 inline-block align-middle cursor-pointer"
                >
                  <span
                    data-v-83be86ac
                    className="block px-2 text-11 border-r border-black-300 border-none"
                  >
                    Responsible Gaming
                  </span>
                </li>
              </ul>
            </div>
          </>
        )}
      </section>
    </div>
  ) : (
    <div
      id="page-container"
      style={{ "--6e245f6e": "url(/assets/images/velki-desktop-bg.webp)" }}
    >
      <div
        data-v-58b8c71f
        id="desktop-bg-logo"
        className="flex justify-center items-center col-start-1 col-end-1"
      >
        <img
          data-v-58b8c71f
          width={323}
          height={101}
          className="w-full max-w-xs"
          alt="desktop-bg-logo"
          src="/assets/images/velki-logo-desktop.webp"
        />
      </div>
      <section
        id="main-container"
        // style={{ overflowX: "hidden", minHeight: "100%" }}
        className="relative col-start-2 col-end-2 container h-screen mx-auto overflow-y-scroll overflow-x-hidden bg-black-100"
      >
        <HeaderVelkie />
        <Outlet />
        <main className="min-h-full-with-header-footer">
          {children}
          <BetSlipVelkie />
        </main>
        {location?.pathname?.split("/")[1] != "match-detail-velki" && (
          <BottomNavigation />
        )}
        {sidebarModal && <SidebarVelkie setSidebarModal={setSidebarModal} />}
        {showBets && <MyBetsVelkie />}
        {loading && (
          <div
            data-v-5837125a
            data-v-fa12c4fa
            className="loading-wrapper fixed left-0 top-0 z-50 w-full h-full flex justify-center items-center text-xl text-center text-primary"
          >
            <div
              data-v-5837125a
              className="loading-body w-28 h-28 flex justify-center items-center border border-solid border-primary rounded-lg"
            >
              <div data-v-5837125a className="loading-spinner relative w-1/2" />
            </div>
          </div>
        )}
        {toastObject?.status && (
          <NewToast
            type={toastObject?.type}
            title={toastObject?.title}
            message={toastObject?.message}
            onClose={() => {
              setToastObject({});
              setBetSlipObject({});
            }}
            playType={toastObject?.playType}
          />
        )}
        {(parlay || type == "multi") &&
          parlyBet?.length > 0 &&
          !isEmpty(user) && (
            <div
              onClick={() => setShowParlyBet(true)}
              data-v-63c2856d
              className="stickyLeftContainer fixed left-2 z-10 pb-7px flex gap-2 flex-col justify-end items-end"
              style={{ "--772806b8": "4.3rem" }}
            >
              <div className="relative cursor-pointer flex flex-col items-center justify-center w-45px h-45px rounded-full bg-primary text-menu-active-icon font-bold">
                <span className="absolute text-22 icon-parlay-list" />
                <span className="absolute flex justify-center items-center rounded-full w-4 h-4 text-9 font-bold text-white bg-parlay-down top-1.5 right-1.5">
                  <span className="scale-75">{parlyBet?.length}</span>
                </span>
              </div>
            </div>
          )}
        {showParlyBet && parlyBet?.length > 0 && !isEmpty(user) && (
          <BetSlipParlayVelkie />
        )}
        <div className="flex justify-center items-center flex-col text-center mt-40px">
          <Link to="#" className="inline-block mb-1">
            <img
              alt="android download"
              width={115}
              height={41}
              className="w-120px h-auto mx-auto"
              src={require("../../assets/images/btn-android-dl.webp")}
            />
          </Link>
          <span className="text-11 text-black-600">
            v1.11 - 2022/3/8 - 2.6MB
          </span>
          <p className="test-app" />
        </div>
        <div className="social relative flex justify-center items-center py-20px">
          <a
            href="https://t.me/akash_malik"
            target="_blank"
            className="block cursor-pointer mx-1"
          >
            <span className="text-30 icon-telegram" />
          </a>
          <a
            href={+447520636263}
            target="_blank"
            className="block cursor-pointer mx-1"
          >
            <div
              data-v-5a06812e
              className="icon-whatsapp text-30 block cursor-pointer mx-1"
            />
          </a>

          <a
            href="https://www.facebook.com/groups/velki.live"
            target="_blank"
            className="block cursor-pointer mx-1"
          >
            <span className="text-30 icon-facebook" />
          </a>
        </div>
        <div data-v-83be86ac className="px-3 mb-10px text-center">
          <ul data-v-83be86ac>
            <li
              data-v-83be86ac
              className="pb-2 inline-block align-middle cursor-pointer"
            >
              <span
                data-v-83be86ac
                className="block px-2 text-11 border-r border-black-300"
              >
                Privacy Policy
              </span>
            </li>
            <li
              data-v-83be86ac
              className="pb-2 inline-block align-middle cursor-pointer"
            >
              <span
                data-v-83be86ac
                className="block px-2 text-11 border-r border-black-300"
              >
                Terms and Conditions
              </span>
            </li>
            <li
              data-v-83be86ac
              className="pb-2 inline-block align-middle cursor-pointer"
            >
              <span
                data-v-83be86ac
                className="block px-2 text-11 border-r border-black-300"
              >
                Rules and Regulations
              </span>
            </li>
            <li
              data-v-83be86ac
              className="pb-2 inline-block align-middle cursor-pointer"
            >
              <span
                data-v-83be86ac
                className="block px-2 text-11 border-r border-black-300"
              >
                KYC
              </span>
            </li>
            <li
              data-v-83be86ac
              className="pb-2 inline-block align-middle cursor-pointer"
            >
              <span
                data-v-83be86ac
                className="block px-2 text-11 border-r border-black-300 border-none"
              >
                Responsible Gaming
              </span>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default VelkieLayout;
